const actions = {
  ROLE_ADD_BEGIN: 'ROLE_ADD_BEGIN',
  ROLE_ADD_SUCCESS: 'ROLE_ADD_SUCCESS',
  ROLE_ADD_ERR: 'ROLE_ADD_ERR',
  
  ROLES_READ_BEGIN: 'ROLES_READ_BEGIN',
  ROLES_READ_SUCCESS: 'ROLES_READ_SUCCESS',
  ROLES_READ_ERR: 'ROLES_READ_ERR',

  ROLE_UPDATE_BEGIN: 'ROLE_UPDATE_BEGIN',
  ROLE_UPDATE_SUCCESS: 'ROLE_UPDATE_SUCCESS',
  ROLE_UPDATE_ERR: 'ROLE_UPDATE_ERR',

  ROLE_DELETE_BEGIN: 'ROLE_DELETE_BEGIN',
  ROLE_DELETE_SUCCESS: 'ROLE_DELETE_SUCCESS',
  ROLE_DELETE_ERR: 'ROLE_DELETE_ERR',

  ROLE_READ_BEGIN: 'ROLE_READ_BEGIN',
  ROLE_READ_SUCCESS: 'ROLE_READ_SUCCESS',
  ROLE_READ_ERR: 'ROLE_READ_ERR',

  ROLE_UPLOAD_BEGIN: 'ROLE_UPLOAD_BEGIN',
  ROLE_UPLOAD_SUCCESS: 'ROLE_UPLOAD_SUCCESS',
  ROLE_UPLOAD_ERR: 'ROLE_UPLOAD_ERR',

  ROLE_PERMISSIONS_READ_BEGIN: 'ROLE_PERMISSIONS_READ_BEGIN',
  ROLE_PERMISSIONS_READ_SUCCESS: 'ROLE_PERMISSIONS_READ_SUCCESS',
  ROLE_PERMISSIONS_READ_ERR: 'ROLE_PERMISSIONS_READ_ERR',

  ROLE_PERMISSIONS_UPDATE_BEGIN: 'ROLE_PERMISSIONS_UPDATE_BEGIN',
  ROLE_PERMISSIONS_UPDATE_SUCCESS: 'ROLE_PERMISSIONS_UPDATE_SUCCESS',
  ROLE_PERMISSIONS_UPDATE_ERR: 'ROLE_PERMISSIONS_UPDATE_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.ROLES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.ROLES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.ROLES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.ROLE_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.ROLE_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.ROLE_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.ROLE_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.ROLE_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.ROLE_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.ROLE_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.ROLE_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.ROLE_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.ROLE_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.ROLE_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.ROLE_READ_ERR,
      err,
    };
  },

  axiosRolePermissionsReadBegin: () => {
    return {
      type: actions.ROLE_PERMISSIONS_READ_BEGIN,
    };
  },

  axiosRolePermissionsReadSuccess: data => {
    return {
      type: actions.ROLE_PERMISSIONS_READ_SUCCESS,
      data,
    };
  },

  axiosRolePermissionsReadErr: err => {
    return {
      type: actions.ROLE_PERMISSIONS_READ_ERR,
      err,
    };
  },

  axiosRolePermissionsUpdateBegin: () => {
    return {
      type: actions.ROLE_PERMISSIONS_UPDATE_BEGIN,
    };
  },

  axiosRolePermissionsUpdateSuccess: data => {
    return {
      type: actions.ROLE_PERMISSIONS_UPDATE_SUCCESS,
      data,
    };
  },

  axiosRolePermissionsUpdateErr: err => {
    return {
      type: actions.ROLE_PERMISSIONS_UPDATE_ERR,
      err,
    };
  },

};

export default actions;
